import { render, staticRenderFns } from "./AjustesDestino.vue?vue&type=template&id=c5df091e"
import script from "./AjustesDestino.vue?vue&type=script&lang=js"
export * from "./AjustesDestino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports